import { Axios } from 'axios';
import { injectable } from 'inversify';

import { ProfilePhotoModel } from '@vp/profile/core/model/ProfilePhotoModel';
import { SlideshowMediaLoader } from '@vp/slideshow/core/interface/SlideshowMediaLoader';

@injectable()
export class SlideshowMediaCacheLoader implements SlideshowMediaLoader {
  constructor(private readonly http: Axios) {}

  async loadImages(images: ProfilePhotoModel[]): Promise<ProfilePhotoModel[]> {
    const successfulImages: ProfilePhotoModel[] = [];

    await Promise.all(
      images.map(image => {
        return new Promise(resolve => {
          const img = new Image();
          img.src = image.staticUrl ?? image.url;
          img.onload = (): void => {
            successfulImages.push(image);
            resolve(null);
          };
          img.onerror = (): void => resolve(null);
        });
      }),
    );

    return successfulImages;
  }

  async loadAudio(audioUrl: string): Promise<Blob> {
    try {
      const response = await this.http.get(audioUrl, { responseType: 'arraybuffer' });
      return new Blob([response.data], { type: 'audio/mpeg' });
    } catch {
      // TODO log error
      return new Blob();
    }
  }
}
